export enum ActionType {
  SET_PROJECT = 'setProject',
  SET_USER = 'setUser',
  SET_SITES = 'setSites',
  SET_IS_LOADING = 'setIsLoading',
  SET_PROJECTS = 'setProjects',
  SET_ARE_SITES_LOADING = 'setAreSitesLoading',
  SET_ARE_PROJECTS_LOADING = 'setAreProjectsLoading',
  SET_PROJECTS_FILTER = 'setProjectsFilter'
}
